<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          탐지
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Detect</a>
          </li>
      </ul>
    </div>
  <vcl-facebook v-if="loading"></vcl-facebook>
  <div v-else>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>탐지 상세</strong>
              <span class="float-right" style="font-size: 13px">탐지 시각 {{model.created_at | sdate}}</span>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>Agent</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP 주소(외부)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP 주소(내부)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <table class="text-center h5">
            <tbody class="h6">
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="탐지된 시각을 표시합니다">
                    탐지 시각
                    <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                  </span>
                </td>
                <td class="p-2">{{model.created_at | datetime}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="격리 여부를 표시합니다">
                    격리(백업)
                    <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                  </span>
                </td>
                <td class="p-2 text-danger font-weight-bold">{{model.is_backup ? `예` : `아니오`}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="탐지된 정책의 분류를 표시합니다">
                    정책
                    <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.type : '-'}}</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="탐지된 정책의 코드를 탐지 근거로 표시합니다">
                    탐지 근거
                    <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                  </span>
                </td>
                <td class="p-2">{{model && model.description ? model.description.code : '-'}}</td>
              </tr>
              <tr>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="정규식,URL 정책으로 탐지시에 데이터를 표시합니다">
                  탐지 근거 데이터(파일 내용)
                  <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                </span>
                <td class="p-2" v-if="model && model.description && model.description.value">{{ model.description.value || '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
              <tr>
                <td class="p-2">
                  <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="파일에서 탐지된 부분의 라인 수를 표시합니다">
                    라인
                    <span class="text-info"><i style="cursor:pointer" class="fas fa-question-circle"></i></span>
                  </span>
                </td>
                <td class="p-2" v-if="model && model.description">{{model.description.numerical > 0 ? model.description.numerical : '-'}}</td>
                <td class="p-2" v-else>-</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <b-button size="sm" class="float-left" variant="info" @click="agent"> 에이전트({{agentName}}) 바로 가기 </b-button>
          <!-- <b-button size="sm" class="float-left ml-2" variant="info" @click="result"> 점검 결과 바로 가기 </b-button> -->
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <Result v-if="model.result" :result_data="model.result" />
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
